export const CCActions = {
  CC_MODE: "CC_MODE",
  EXPIRED_FORM_FILLED: "EXPIRED_FORM_FILLED",
  LAST_FORM_STEP: "LAST_FORM_STEP",
  FORM_DRIVER_OK: "FORM_DRIVER_OK",
  FORM_DRIVER_OK_TWO: "FORM_DRIVER_OK_TWO",
  PIC_POLICY_OK: "PIC_POLICY_OK",
  SELECT_POLICY_OK: "SELECT_POLICY_OK",
  SELECT_COVERAGE_OK: "SELECT_COVERAGE_OK",
  SELECT_DECISION_OK: "SELECT_DECISION_OK",
  PAYMENT_CONFIRMATION_OK: "PAYMENT_CONFIRMATION_OK",
  CONTINUE_PROCESS_PATH: "CONTINUE_PROCESS_PATH",
  SELECTED_VEHICLE_DATA: "SELECTED_VEHICLE_DATA",
  PLANS_FULL_COVERAGE: "PLANS_FULL_COVERAGE",
  COVERAGE_SELECTED: "COVERAGE_SELECTED",
  DATA_TO_BACKEND_FC: "DATA_TO_BACKEND_FC",
  CUSTOMER_QUOTES_FC: "CUSTOMER_QUOTES_FC",
  OLD_POLICY_FILE_INFO: "OLD_POLICY_FILE_INFO",
  GET_POLICY_AFTER_EXPIRATION: "GET_POLICY_AFTER_EXPIRATION",
  KYC_FILLED: "KYC_FILLED",
  DOWNLOAD_POLICY_ERROR_MESSAGE_FC: "DOWNLOAD_POLICY_ERROR_MESSAGE_FC",
  DOWNLOAD_POLICY_RESPONSE_FC: "DOWNLOAD_POLICY_RESPONSE_FC",
  FC_POLICIES_BENEFITS: "FC_POLICIES_BENEFITS",
  FC_POLICIES_BENEFITS_STATS: "FC_POLICIES_BENEFITS_STATS",
  CC_LANDING: "CC_LANDING",
  FC_POLICIES_LOADED: "FC_POLICIES_LOADED",
  FC_RATINGS: "FC_RATINGS",
  FC_DEDUCTIBLE_SELECTED: "FC_DEDUCTIBLE_SELECTED",
  INSPECTION_PROCESS: "INSPECTION_PROCESS",
  SOAP_PAYMENT_RESPONSE: "SOAP_PAYMENT_RESPONSE",
  FC_PAYMENT_PENDING_FOR_COMPLETE: "FC_PAYMENT_PENDING_FOR_COMPLETE",
  SETSHAREDINADMIN: "SETSHAREDINADMIN",
  FETCH_LIMITES_ADICIONALES: "FETCH_LIMITES_ADICIONALES",

  setCCMode: (cc_mode) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.CC_MODE,
        cc_mode,
      });
    };
  },
  setExpiredFormFilled: (expired_form_filled) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.EXPIRED_FORM_FILLED,
        expired_form_filled,
      });
    };
  },
  setLastFormStep: (last_form_step) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.LAST_FORM_STEP,
        last_form_step,
      });
    };
  }, 
  setFormDriverOK: (form_driver_ok) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FORM_DRIVER_OK,
        form_driver_ok,
      });
    };
  },
  setFormDriverOKTwo: (form_driver_ok_two) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FORM_DRIVER_OK_TWO,
        form_driver_ok_two,
      });
    };
  },
  setPicPolicyOK: (pic_policy_ok) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.PIC_POLICY_OK,
        pic_policy_ok,
      });
    };
  },
  setSelectPolicyOK: (select_policy_ok) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.SELECT_POLICY_OK,
        select_policy_ok,
      });
    };
  },
  setSelectCoverageOK: (select_coverage_ok) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.SELECT_COVERAGE_OK,
        select_coverage_ok,
      });
    };
  },
  setSelectDedicionOK: (select_decision_ok) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.SELECT_DECISION_OK,
        select_decision_ok,
      });
    };
  },
  setPaymentConfirmationOK: (payment_confirmation_ok) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.PAYMENT_CONFIRMATION_OK,
        payment_confirmation_ok,
      });
    };
  },
  setContinueProcessPath: (continue_process_path) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.CONTINUE_PROCESS_PATH,
        continue_process_path,
      });
    };
  },
  setSelectedVehicleData: (selected_vehicle_data) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.SELECTED_VEHICLE_DATA,
        selected_vehicle_data,
      });
    };
  },
  savePlansFullCoverage: (plans_full_coverage) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.PLANS_FULL_COVERAGE,
        plans_full_coverage,
      });
    };
  },
  setCoverageSelected: (coverage_selected) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.COVERAGE_SELECTED,
        coverage_selected,
      });
    };
  },
  setDataToBackendFC: (data_to_backend_fc) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.DATA_TO_BACKEND_FC,
        data_to_backend_fc,
      });
    };
  },
  setCustomerQuotesFC: (customer_quotes_fc) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.CUSTOMER_QUOTES_FC,
        customer_quotes_fc,
      });
    };
  },
  setOldPolicyFileInfo: (old_policy_file_info) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.OLD_POLICY_FILE_INFO,
        old_policy_file_info,
      });
    };
  },
  setGetPolicyAfterExpiration: (get_policy_after_expiration) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.GET_POLICY_AFTER_EXPIRATION,
        get_policy_after_expiration,
      });
    };
  },
  setKYCFilled: (kyc_filled) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.KYC_FILLED,
        kyc_filled,
      });
    };
  },
  setDownloadPolicyErrorMessageFC: (download_policy_error_message_fc) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.DOWNLOAD_POLICY_ERROR_MESSAGE_FC,
        download_policy_error_message_fc,
      });
    };
  },
  setDownloadPolicyResponseFC: (download_policy_response_fc) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.DOWNLOAD_POLICY_RESPONSE_FC,
        download_policy_response_fc,
      });
    };
  },
  setFCPoliciesBenefits: (fc_policies_benefits) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FC_POLICIES_BENEFITS,
        fc_policies_benefits,
      });
    };
  },
  setFCPoliciesBenefitsStats: (fc_policies_benefits_stats) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FC_POLICIES_BENEFITS,
        fc_policies_benefits_stats,
      });
    };
  },
  setCCLanding: (cc_landing) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.CC_LANDING,
        cc_landing,
      });
    };
  },
  setFCPoliciesLoaded: (fc_policies_loaded) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FC_POLICIES_LOADED,
        fc_policies_loaded,
      });
    };
  },
  setFCRatings: (fc_ratings) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FC_RATINGS,
        fc_ratings,
      });
    };
  },
  setFCDeductibleSelected: (fc_deductible_selected) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FC_DEDUCTIBLE_SELECTED,
        fc_deductible_selected,
      });
    };
  },
  setInspectionProcess: (inspection_process) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.INSPECTION_PROCESS,
        inspection_process,
      });
    };
  },
  setSoapPaymentResponse: (soap_payment_response) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.SOAP_PAYMENT_RESPONSE,
        soap_payment_response,
      });
    };
  },
  setFCPaymentPendingForComplete: (fc_payment_pending_for_complete) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FC_PAYMENT_PENDING_FOR_COMPLETE,
        fc_payment_pending_for_complete,
      });
    };
  },
  setSharedInAdmin: (value) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.SETSHAREDINADMIN,
        value
      })
    }
  },
  fetchLimitesAdicionales: (value) => {
    return (dispatch) => {
      dispatch({
        type: CCActions.FETCH_LIMITES_ADICIONALES,
        value
      })
    }
  }
};
